// Module-load detection so React hooks can read this synchronously without
// triggering re-renders. Used to disable expensive desktop-only effects on
// mobile (scroll-linked parallax, Lenis smooth scroll, infinite animations,
// PostHog session recording) which were causing the site to "hang the phone".
export const IS_MOBILE =
  typeof window !== "undefined" &&
  (
    matchMedia("(hover: none) and (pointer: coarse)").matches ||
    /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
  );
